import * as React from 'react';
import classNames from 'classnames/bind';
import { useIntl } from 'umi';
import copyToClipboard from 'copy-to-clipboard';
import { message } from 'antd';
import { Icon, Button } from '@/components';
import { checkBrowerAble2 } from '@/utils/deviceCheck';
import Style from './index.less';

export interface p {
  size?: string;
  show?: boolean;
  onClose?(): void;
}

const $c = classNames.bind(Style);

const urls: Record<string, string> = {
  windows: 'https://popo.gdl.netease.com/92.0.4515.159_chrome_installer.exe',
  mac: 'https://popo.gdl.netease.com/googlechrome159.dmg',
  // android: 'https://popo.gdl.netease.com/googlechrome91.0.4472.164_2265_android.apk',
  android: 'https://popo.gdl.netease.com/chrome_android_112.apk',
};

const ErrorBrowserHeader: React.FC<p> = ({ size = 'large', show = false, onClose }) => {
  const { formatMessage } = useIntl();
  const isSmall = React.useMemo(() => {
    return size === 'small';
  }, [size]);

  const checkResult = checkBrowerAble2();

  const copy = React.useCallback(() => {
    copyToClipboard(window.localStorage.getItem('url') || '');
    message.info({
      content: formatMessage({ id: 'COPY_SUCCESS' }),
      icon: null,
    });
  }, []);

  function downloadApp() {
    const href = urls[checkResult!.type] || '';
    const a = document.createElement('a');
    a.setAttribute('href', `${href}?_=${new Date().getTime()}`);
    a.setAttribute('target', '_blank');
    a.click();
  }
  return (
    checkResult && (
      <div className={$c('error-browser-header', { small: size === 'small', show })}>
        {window.isMobile && (
          <div className={$c('close-btn')} onClick={onClose}>
            <Icon name="icon-close_nor" size={24} className={$c('btn-icon')} />
          </div>
        )}
        <div className={$c('content')}>
          <div className={$c('left-tip')}>
            <img
              src={
                checkResult?.browser !== 'safari'
                  ? require('./image/Chrome.png')
                  : require('./image/Safari.png')
              }
              alt="浏览器"
              className={$c('logo')}
            />
            <div className={$c('tip')}>
              {formatMessage({ id: 'BROWSER_INCOMPATIBLE' })}{' '}
              {!(isSmall && !window.isMobile) ? <br /> : ', '}
              {checkResult && formatMessage({ id: 'BROWSER_VERSION_UP' }, checkResult)}
            </div>
          </div>
          <div className={$c('right-buttons')}>
            {checkResult?.browser === 'chrome' && (
              <Button className={$c('btn', 'download')} type="primary" onClick={downloadApp}>
                <Icon
                  name="icon-fold_down"
                  size={window.isMobile ? 16 : isSmall ? 16 : 24}
                  className={$c('btn-icon')}
                />
                {formatMessage({ id: 'DOWNLOAD_BROWSER' })}
              </Button>
            )}
            <Button onClick={copy} className={$c('btn', 'copy')} type="primary">
              <Icon
                name="icon-link"
                size={window.isMobile ? 16 : isSmall ? 16 : 24}
                className={$c('btn-icon')}
              />
              {formatMessage({ id: 'COPY_URL' })}
            </Button>
          </div>
        </div>
      </div>
    )
  );
};

export default ErrorBrowserHeader;
